<template>
  <div class="login-page">
    <form class="login-panel" @submit.prevent="handleLogin">
      <div class="brand-line">
        <div class="login-mark">P</div>
        <div>
          <h1>爬宠内部管理台</h1>
          <p>运营、设计与数据协作空间</p>
        </div>
      </div>

      <label class="login-field">
        <span>工号 / 账号</span>
        <input v-model.trim="form.username" autocomplete="username" type="text" placeholder="请输入内部账号" />
      </label>
      <label class="login-field">
        <span>密码</span>
        <input v-model="form.password" autocomplete="current-password" type="password" placeholder="请输入密码" />
      </label>

      <div v-if="errorMessage" class="login-error" role="alert">{{ errorMessage }}</div>
      <button class="login-button" type="submit" :disabled="loading">
        {{ loading ? "正在验证..." : "进入管理台" }}
      </button>
    </form>
  </div>
</template>

<script>
import { loginAdmin } from "../api/adminAuth"
import { saveAdminSession } from "../utils/adminSession"

export default {
  name: "LoginView",
  data() {
    return {
      loading: false,
      errorMessage: "",
      form: { username: "", password: "" }
    }
  },
  methods: {
    async handleLogin() {
      if (!this.form.username || !this.form.password) {
        this.errorMessage = "请输入账号和密码"
        return
      }
      this.loading = true
      this.errorMessage = ""
      try {
        const res = await loginAdmin(this.form)
        const data = res.data || {}
        saveAdminSession(data.token, data.user)
        if (data.user && data.user.mustChangePassword) {
          this.$router.replace("/change-password")
        } else {
          this.$router.replace(this.$route.query.redirect || "/dashboard")
        }
      } catch (error) {
        this.errorMessage = error.message || "登录失败"
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: #f3f5f7;
}
.login-panel {
  width: min(420px, 100%);
  padding: 32px;
  border: 1px solid #dfe4ea;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 18px 45px rgba(23, 31, 44, 0.08);
}
.brand-line { display: flex; align-items: center; gap: 14px; margin-bottom: 28px; }
.login-mark {
  width: 48px; height: 48px; display: grid; place-items: center; flex: 0 0 auto;
  border-radius: 8px; background: #1f6b4f; color: #fff; font-size: 22px; font-weight: 800;
}
h1 { margin: 0; color: #17202b; font-size: 22px; letter-spacing: 0; }
p { margin: 5px 0 0; color: #73808f; font-size: 13px; }
.login-field { display: block; margin-top: 18px; }
.login-field span { display: block; margin-bottom: 7px; color: #394655; font-size: 13px; font-weight: 600; }
.login-field input {
  width: 100%; height: 44px; padding: 0 12px; border: 1px solid #cfd7df; border-radius: 6px;
  color: #17202b; outline: none;
}
.login-field input:focus { border-color: #1f6b4f; box-shadow: 0 0 0 3px rgba(31, 107, 79, 0.1); }
.login-error { margin-top: 14px; padding: 10px 12px; border-radius: 6px; background: #fff0ee; color: #b43b2d; font-size: 13px; }
.login-button {
  width: 100%; height: 44px; margin-top: 22px; border: 0; border-radius: 6px;
  background: #1f6b4f; color: #fff; font-weight: 700; cursor: pointer;
}
.login-button:disabled { opacity: .65; cursor: wait; }
</style>
